module.exports = __webpack_public_path__ + "static/media/Loki.2768feb2.png";